import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            height: '100%',
            paddingTop: '50px',
            paddingRight: '40px',
            paddingBottom: '10px',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '20px',
            position: 'relative',
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
            '&.flex-j-e': {
                justifyContent: 'end',
            },
        },
        clean: {
            fontSize: '2.4rem',
            color: colors.color4,
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        hide: {
            visibility: 'hidden',
        },
        section: {
            marginBottom: '32px',
        },
        mineHeaderTable: {
            '&.MuiTableCell-head': {
                width: '40px',
            },
        },
        headerTable: {
            '&.MuiTableCell-head': {
                minWidth: '100px',
            },
            '&.MuiTableCell-root.MuiTableCell-root': {
                vertialAlign: 'middle',
            },
        },
        containerStatus: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            width: '100%',
            height: '100%',
        },
        baseMenu: {
            '& .MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper':
            {
                boxShadow: `1px 1px ${colors.color13}30`,
            },
        },
    }
}

export { useStyles }
